import React from 'react';
import { ProgressBar } from 'react-toolbox/lib/progress_bar';
import styles from 'components/syncingInput.css';
import stylesProgressBar from 'components/syncingInputProgressBar.css';

const syncingInput = Component => ({
  inputTheme,
  progressBarTheme,
  syncing,
  ...props
}) =>
  <div className={styles.container}>
    <Component theme={inputTheme} disabled={syncing} {...props} />
    {syncing &&
      <ProgressBar
        theme={progressBarTheme || stylesProgressBar}
        type="circular"
        mode="indeterminate"
      />}
  </div>;

export default syncingInput;
